/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedEmailAddressRequest
 */
export interface APIPatchedEmailAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedEmailAddressRequest
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIPatchedEmailAddressRequest
     */
    verified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIPatchedEmailAddressRequest
     */
    primary?: boolean;
}

/**
 * Check if a given object implements the APIPatchedEmailAddressRequest interface.
 */
export function instanceOfAPIPatchedEmailAddressRequest(value: object): value is APIPatchedEmailAddressRequest {
    return true;
}

export function APIPatchedEmailAddressRequestFromJSON(json: any): APIPatchedEmailAddressRequest {
    return APIPatchedEmailAddressRequestFromJSONTyped(json, false);
}

export function APIPatchedEmailAddressRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedEmailAddressRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'verified': json['verified'] == null ? undefined : json['verified'],
        'primary': json['primary'] == null ? undefined : json['primary'],
    };
}

export function APIPatchedEmailAddressRequestToJSON(value?: APIPatchedEmailAddressRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'verified': value['verified'],
        'primary': value['primary'],
    };
}

